import React, { useRef } from 'react';

const ImportBankFile = ({ onImport }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (ext === 'csv' || ext === 'xlsx') {
      const text = await file.text();
      // Simple CSV parse (assumes header row and no commas in fields)
      const lines = text.trim().split(/\r?\n/);
      const [header, ...rows] = lines;
      const headers = header.split(',');
      const transactions = rows.map((row, idx) => {
        const cols = row.split(',');
        const obj = {};
        headers.forEach((h, i) => {
          obj[h.trim()] = cols[i]?.trim();
        });
        const amount = parseFloat(obj.amount);
        return {
          id: `tx${idx + 1}`,
          transactionDate: obj.transactionDate,
          description: obj.description,
          amount,
          // direction removed, infer from amount sign
          referenceNumber: obj.referenceNumber,
          reconciliationStatus: 'UNMATCHED',
        };
      });
      onImport(transactions);
    } else if (ext === 'pdf') {
      alert('PDF import not implemented in MVP.');
    } else {
      alert('Unsupported file type. Please upload CSV, XLSX, or PDF.');
    }
  };

  return (
    <div className="mb-4">
      <input
        type="file"
        accept=".csv,.xlsx,.pdf"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="mb-2"
      />
    </div>
  );
};

export default ImportBankFile;
